import React, { useEffect, useState } from 'react'
import { BankNoteFlyIcon } from '../../../assets/AppIcons'
import { useTheme } from '../../../utils/ThemeColorContext'
import { useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'

import PageHeader from '../../../components/PageHeader'
import SpinnerLarge from '../../../components/SpinnerLarge'
import SubPageHeader from '../../../components/SubPageHeader'
import PrimaryButton from '../../../components/buttons/PrimaryButton'
import DefaultPage from '../DefaultPage'
import Spinner from '../../../components/Spinner'
import JourneyRoute from '../../../navigation/JourneyRoute'
import OnEnter from '../../../components/navigation/onEnter'
import { AppStyles } from '../../../assets/styles/AppStyles'
import FormInput from '../../../components/inputs/FormInput'
import { getProfile } from '../../../redux/Actions/getMethods'
import { setupApplication } from '../../../redux/Actions/postMethods'

function UpfrontAmount() {
  const dispatch = useDispatch()
  const { loading, token } = useSelector((state) => state.authReducer)
  const { getApplication, profile } = useSelector((state) => state.dataReducer)
  const { color, isSmallScreen } = useTheme()
  const navigate = useNavigate()
  const [amount, setAmount] = useState('0')
  const [err, setErr] = useState('')

  const parsedAmount = parseInt(amount) || 0
  const isValid = parsedAmount >= 1000 && parsedAmount % 100 === 0

  useEffect(() => {
      if (getApplication[0]?.requested_amount) {
        setAmount(getApplication[0]?.requested_amount)
      }
    }, [])

  const handleAmountChange = (e) => {
    const raw = e.target.value.replace(/[^0-9]/g, '')
    const next = raw.replace(/^0+/, '') || '0'
    setAmount(next)
    const num = parseInt(next) || 0
    if (next !== '0') {
      if (num < 1000) {
        setErr('Minimum loan amount is £1,000')
      } else if (num % 100 !== 0) {
        setErr('Amount must be a multiple of £100')
      } else {
        setErr('')
      }
    } else {
      setErr('')
    }
  }

  const handleContinue = async () => {
    localStorage.setItem('loan_amount', amount)
    localStorage.setItem(`loan_amount-${token?.email}`, amount)
    const getPro = await dispatch(getProfile())
    if (getPro) {
      const payload = {
        requested_amount: amount,
      }
      await dispatch(setupApplication(payload))
      navigate('/employment')
    }
  }

  return (
    <DefaultPage>
      <JourneyRoute />
      {loading ? (
        <SpinnerLarge />
      ) : (
        <div className="relative container mx-auto md:w-[564px] md:space-y-10  ">
          <PageHeader
            title={'Your loan amount'}
            backButtonTitle={'Your reason for loan'}
            prevRoute={'/reason'}
            customDescription={
              <p
                style={
                  isSmallScreen
                    ? {
                        ...AppStyles.Body,
                        color: color.Grey,
                      }
                    : {
                        ...AppStyles.Subheading1,
                        color: color.Grey,
                      }
                }
              >
                Hey
                <span style={{ color: color.BlurpleTeal }}>
                  {' '}
                  {profile?.first_name}
                </span>
                , how much are you looking to borrow?
              </p>
            }
          />
          <div
            style={{ backgroundColor: color.White }}
            className="rounded-3xl p-6 space-y-6"
          >
            <SubPageHeader Icon={BankNoteFlyIcon} text={'Loan amount'} />
            <div className="w-full flex flex-col space-y-6 md:space-y-0 md:flex-row md:space-x-6">
              <div className="rounded-xl w-full">
                <div className="flex flex-col justify-end space-y-3 w-full">
                  <FormInput
                    placeholder={'Loan amount'}
                    type={'text'}
                    leftSign={true}
                    name={'loan_amount'}
                    value={Number(amount).toLocaleString()}
                    onChange={handleAmountChange}
                    enterKeyHint={'done'}
                  />
                  {err && (
                    <p style={{ ...AppStyles.Caption1, color: color.SoftPink }}>
                      {err}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <OnEnter
            actionFunction={() => {
              if (!isValid) {
                return
              }
              handleContinue()
            }}
          />

          <div
            style={{
              marginTop: isSmallScreen && '24px',
              background: !isSmallScreen && 'linear-gradient(0deg, #F5F7FC 0%, rgba(245, 247, 252, 0) 100%)',
            }}
            className={
              isSmallScreen ? (
                `mt-10 md:max-w-[588px] m-[auto] fixed w-full bottom-0 px-6 pb-6 md:p-0 flex flex-col-reverse gap-5 md:gap-10 md:flex-row bg-[#F5F7FC]`
              ) : (
                `px-6 pb-6 md:p-0 fixed bottom-0 md:relative  w-full `
              )
            }
          >
            {isSmallScreen && (
              <>
                <div
                  className="absolute inset-x-0 top-[-32px] h-[24px] bg-gradient-to-t from-[#F5F7FC] to-[#F5F7FC00] pointer-events-none"
                ></div>
                <div
                  className="absolute inset-x-0 top-[-8px] h-[8px] bg-[#F5F7FC] pointer-events-none"
                />
              </>
            )}
            <PrimaryButton
              id={'upfront-amount'}
              text={loading ? <Spinner /> : 'Continue'}
              disabled={!isValid}
              onClick={() => {
                if (loading || !isValid) {
                  return
                }
                handleContinue()
              }}
              className={' md:w-[260px]'}
            />
          </div>
        </div>
      )}
    </DefaultPage>
  )
}

export default UpfrontAmount
